import React from 'react'

type Props = {
  title: string
  icon: string
  value: number | string
  valueSuffix: string
  change?: number
  changeSuffix?: string
}

export const KPI: React.FC<Props> = ({
  title,
  icon,
  value,
  valueSuffix,
  change,
  changeSuffix,
}) => {
  const isPositive = change ? change >= 0 : false

  const changeIcon = isPositive ? 'pi-arrow-up' : 'pi-arrow-down'
  const changeColor = isPositive ? 'text-green-600' : 'text-red-600'
  const changeCircleColor = isPositive ? 'bg-green-50' : 'bg-red-50'

  return (
    <div className="flex flex-column h-full gap-1 bg-white border-round-md shadow-1 p-3">
      <div className="flex justify-content-between">
        <h4 className="m-0 text-xs font-medium">{title}</h4>
        <i
          className={`pi ${icon} text-primary`}
          style={{ fontSize: '1.5rem' }}
        ></i>
      </div>

      <div>
        <span className="font-bold">
          <span className="text-xl">{value}</span>{' '}
          <span className="text-base">{valueSuffix}</span>
        </span>
      </div>

      {change && (
        <div className="flex gap-1 text-xs">
          <span className={`flex gap-1 ${changeColor}`}>
            <span
              className={`${changeCircleColor} border-circle w-1rem h-1rem block flex align-items-center justify-content-center`}
            >
              <i
                className={`pi ${changeIcon}`}
                style={{ fontSize: '0.5rem' }}
              ></i>
            </span>

            <span>{change} </span>
          </span>
          <span className="text-400">{changeSuffix}</span>
        </div>
      )}
    </div>
  )
}
